import { render, staticRenderFns } from "./AamsGiftBaseItem.vue?vue&type=template&id=46626228&scoped=true&"
import script from "./AamsGiftBaseItem.vue?vue&type=script&lang=js&"
export * from "./AamsGiftBaseItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46626228",
  null
  
)

export default component.exports